import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";
import { refreshFilesFromApi } from "@/store/thunks/sixDetail/refreshFilesThunk";

const POLL_INTERVAL_MS = 5000; // 5 seconds
const MAX_POLL_DURATION_MS = 60000; // 60 seconds
const MAX_ATTEMPTS = MAX_POLL_DURATION_MS / POLL_INTERVAL_MS; // 12 attempts

/**
 * Polls refreshFilesFromApi every 5 seconds until the file list changes.
 * Returns true if files changed, false after 60 seconds timeout.
 */
export const pollFilesUntilNewFile = createAppAsyncThunk<
  boolean,
  { sixId: string }
>(
  "sixDetail/pollFilesUntilNewFile",
  async({ sixId }, { dispatch, getState, extra }) => {
    // Capture initial file count and CIDs
    const initialFiles = getState().sixDetail.files;
    const initialCids = new Set(initialFiles.map(f => f.cid));
    const initialCount = initialFiles.length;

    for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {

      const result = await dispatch(refreshFilesFromApi(sixId)).unwrap();

      if (!result.skipped) {
        const hasNewFile = result.files.some(f => !initialCids.has(f.cid));
        const countChanged = result.files.length !== initialCount;

        if (hasNewFile || countChanged) {
          return true;
        }
      }

      if (attempt < MAX_ATTEMPTS - 1) {
        await new Promise(resolve => setTimeout(resolve, POLL_INTERVAL_MS));
      }
    }

    return false;
  }
);
